import React from 'react';
import { motion } from 'framer-motion';

const BookingButton = ({ text = "Book Appointment", className = "", variant = "primary" }) => {
  const baseStyles = "px-6 py-3 rounded-full font-medium transition-all duration-300 transform hover:scale-105 shadow-md text-sm md:text-base";
  
  const variants = {
    primary: "bg-rose-gold text-white hover:bg-rose-gold-dark",
    outline: "border-2 border-rose-gold text-rose-gold hover:bg-rose-gold hover:text-white",
    white: "bg-white text-rose-gold hover:bg-gray-100"
  };

  return (
    <motion.a
      href="https://bookings.gettimely.com/hillearcarelimited/bb/book"
      target="_blank"
      rel="noopener noreferrer"
      className={`${baseStyles} ${variants[variant]} ${className} inline-block text-center`}
      whileTap={{ scale: 0.95 }}
    >
      {text}
    </motion.a>
  );
};

export default BookingButton;